import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { CatButton } from '@blocks-react/components/Button';
import styles from './AccountStatusComponent.module.scss';

interface AccountList {
  value: string;
  label: string;
}

interface AccountStatusProps {
  accountStatusTitle: string;
  selectedAccount?: AccountList;
  handleClick: () => void;
  isDisable: boolean;
}

export const AccountStatusComponent: FC<AccountStatusProps> = ({
  accountStatusTitle = '',
  selectedAccount = {},
  handleClick,
  isDisable,
}) => {
  return (
    <div
      data-testid="order_statusr_container"
      className={`d-flex align-items-center justify-content-between ${styles['account_status_wrapper']}`}
    >
      <div>
        <CatHeading variant="body-sm" isDisabled={isDisable}>
          {accountStatusTitle}
        </CatHeading>
        {selectedAccount?.label && (
          <div className={`${styles['account_status_text']} mt-1`}>
            <CatHeading variant="footnote" isDisabled={isDisable} aria-label={selectedAccount.label}>
              {selectedAccount.label}
            </CatHeading>
          </div>
        )}
      </div>
      <CatButton
        hideText={true}
        variant="ghost"
        onClick={handleClick}
        disabled={isDisable}
      >
        <CatIconChevronRight slot="before" aria-label={accountStatusTitle}/>
      </CatButton>
    </div>
  );
};
